module.exports = "<div class=\"c-template-block\" ng-style=\"vm.getBlockStyle()\">\n  <div id=\"template-block-{{::vm.$scope.$id}}\" class=\"c-template-block__content\">\n  </div>\n  <div class=\"debug c-template-block__debug\" ng-bind-html=\"vm.getDebugText()\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/template-block/template-block.html
// module id = 658
// module chunks = 0